(function () {
  var dataEl = document.getElementById('collection-sale-seal-data');
  if (!dataEl) return;

  var sale;
  try {
    sale = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function toCents(text) {
    var amount = parseFloat(text.replace(/[^0-9.]/g, ''));
    return isNaN(amount) ? null : Math.round(amount * 100);
  }

  function toMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function discounted(cents) {
    var off = sale.type === 'fixed' ? Math.round(sale.value * 100) : Math.round((cents * sale.value) / 100);
    return Math.max(cents - off, 0);
  }

  function apply() {
    document.querySelectorAll('.sealsubs-container .sls-price .money').forEach(function (el) {
      var current = el.textContent.trim();
      if (el.dataset.collectionSalePrice === current) return;

      var cents = toCents(current);
      if (cents === null) return;

      var next = toMoney(discounted(cents));
      el.textContent = next;
      el.dataset.collectionSalePrice = next;
    });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      apply();
    }, 50);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  apply();
})();
